<template>
  <div class="row">
    <div v-if="showTitle" class="col-md-12">
      <h2 class="titulo"> {{ bloco.nome }} </h2>
    </div>
    <div class="col-md-12 modulo-customizado">
      <loading v-if="!showContent"></loading>
      <div v-if="ishtml" :class="classemodule" v-html="html"></div>
      <Adsense v-if="isAdmob" :data-ad-client="capub" :data-ad-slot="slot"></Adsense>
    </div>
  </div>
</template>

<script>

  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';
  import $ from 'jquery';

  export default {
    name: "module",
    props: ['bloco'],
    components: {
      Loading
    },
    data() {
      return {
        showContent: false,
        showTitle: false,
        html: '',
        title: '',
        classemodule: '',
        id: '',
        ishtml: false,
        isAdmob: false,
        capub: '',
        slot: '',
      }
    },
    mounted() {
      let self = this;
      get('content/' + this.bloco.id).then(function (response) {
        self.showContent = true;
        self.showTitle = self.bloco.mostrar_nome

        // se for adsense
        if (response.data.result.data.tipo == 1) {
          self.isAdmob = true;
          self.slot = response.data.result.data.slot;
          self.capub = response.data.result.data.capub;
        } else {
          //se for html padrao
          self.classemodule = 'custom-module-' + self.bloco.id;
          self.ishtml = true;
          self.title = response.data.result.data.name;
          self.html = response.data.result.data.content;

          setTimeout(function () {
            $(function () {
              $('.custom-module-' + self.bloco.id).find('script').each(function (index, tag) {
                if (tag.src.length) {
                  $.getScript(tag.src);
                } else {
                  eval($(tag).html());
                }
              });
            });
          }, 1000);
        }
      });
    },
    created() {
    },
    methods: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/home/Module.vue